import { ELabelType } from '../types/newbuildingHeader';

export const BACKGROUND_COLOR = {
  [ELabelType.Reliable]: '#EBF9E6',
  [ELabelType.Problem]: 'error_100',
  [ELabelType.SalesLeader]: 'gray10_100',
};

export const TEXT_COLOR = {
  [ELabelType.Reliable]: '#34AC0A',
  [ELabelType.Problem]: 'white_100',
  [ELabelType.SalesLeader]: 'black_100',
};

export const ICON = {
  [ELabelType.Reliable]: undefined,
  [ELabelType.Problem]: undefined,
  [ELabelType.SalesLeader]: undefined,
};
